const initArticleSliders = () => {
  // Если Swiper не подключён — тихо выходим
  if (typeof window.Swiper === "undefined") return;

  const lists = document.querySelectorAll(".single .article-slider-list");
  const displays = document.querySelectorAll(".single .article-slider-display");
  function fixActiveSlideImages(swiper) {
    const slide = swiper.slides[swiper.activeIndex];
    if (!slide) return;

    const images = slide.querySelectorAll('img');

    let pending = images.length;
    if (!pending) {
      swiper.updateAutoHeight(0);
      return;
    }

    images.forEach(img => {
      const realSrc = img.getAttribute('data-lazy-src');
      const realSrcset = img.getAttribute('data-lazy-srcset');

      if (realSrc) {
        img.src = realSrc;
        img.removeAttribute('data-lazy-src');
      }

      if (realSrcset) {
        img.srcset = realSrcset;
        img.removeAttribute('data-lazy-srcset');
      }

      img.classList.remove('lazyload', 'lazyloading');
      img.classList.add('lazyloaded');

      if (img.complete) {
        pending--;
      } else {
        img.addEventListener(
          'load',
          () => {
            pending--;
            if (pending === 0) {
              swiper.updateAutoHeight(0);
            }
          },
          { once: true }
        );

        img.addEventListener(
          'error',
          () => {
            pending--;
            if (pending === 0) {
              swiper.updateAutoHeight(0);
            }
          },
          { once: true }
        );
      }
    });

    if (pending === 0) {
      swiper.updateAutoHeight(0);
    }
  }

  if (!lists.length || !displays.length) return;

  lists.forEach((listEl, idx) => {
    // Пропускаем, если уже инициализировано
    if (listEl.dataset.sliderInit === "1") return;

    // Пытаемся найти display внутри общего контейнера,
    // например .article-slider, если такой есть в вёрстке.
    // Если не нашли — используем соответствующий по индексу.
    const wrapper =
      listEl.closest(".article-slider, .article-slider-wrap, .slider-block") ||
      null;

    const displayEl =
      (wrapper && wrapper.querySelector(".article-slider-display")) ||
      displays[idx] ||
      null;

    if (!displayEl) return;

    // Защита от повторной инициализации второй стороны пары
    if (displayEl.dataset.sliderInit === "1") return;

    // Создаём слайды
    const thumbs = new Swiper(listEl, {
      spaceBetween: 10,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true,
    });

    const main = new Swiper(displayEl, {
      spaceBetween: 10,
      autoHeight: true,
      thumbs: { swiper: thumbs },
      on: {
    init() {
      fixActiveSlideImages(this);
    },
    slideChangeTransitionStart() {
      fixActiveSlideImages(this);
    }
  }
    });

    // Помечаем как инициализированные
    listEl.dataset.sliderInit = "1";
    displayEl.dataset.sliderInit = "1";

    // Если нужно получить доступ к инстансам позже:
    listEl.__swiperThumbs = thumbs;
    displayEl.__swiperMain = main;
  });
};

export default initArticleSliders;